<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-text-field
                            v-model="model.nombre"
                            label="Nombre"
                            outlined
                            :rules="fieldRequired"
                            dense>
                        </v-text-field>
                    </v-col>
                    <v-col  cols="12" sm="6" md="6">
                        <DatePicker :itemAction="fields.fechaInicial" :on-success="actionFieldData"/>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <DatePicker :itemAction="fields.fechaFinal" :on-success="actionFieldData"/>
                    </v-col>

                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import DatePicker from '@/components/fields/DatePicker'
import { mapGetters } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
export default {
  props: ['model', 'onSuccess', 'onCancel'],
  mixins: [Validate],
  data: () => ({
    fields: {
      fechaInicial: {
        name: 'Fecha Inicial',
        nameid: 'fecha_inicial'
      },
      fechaFinal: {
        name: 'Fecha Final',
        nameid: 'fecha_final'
      }
    }
  }),
  components: {
    DatePicker
  },
  methods: {
    actionFieldData (obj) {
      this.model[obj.id] = (obj.data === undefined) ? null : obj.data
    },
    save () {
      if (this.$refs.form.validate()) {
        this.onSuccess(this.model)
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }
}
</script>

<style>

</style>
